import { FC, HTMLAttributes } from "react";
import st from './servicePackCard.module.scss';
import Heading from "@pages/partners/items/uralchem/components/heading/Heading";
import cn from "classnames";
import { Button2, Type as T } from "@infobis/ui-styles-utils";

interface ServicePackCardProps extends HTMLAttributes<HTMLDivElement>{
    heading: string
    listTitle?: string
    filled?: boolean
    list: string[]
    onOrderBtnClick: () => void
    children?: JSX.Element | JSX.Element[]
}

const ServicePackCard: FC<ServicePackCardProps> = ({heading, listTitle, filled, list, onOrderBtnClick, style, children}) => {
    return (
        <div style={style} className={cn(st['service-pack-card'], filled && st['service-pack-card--filled'])}>
            <Heading.Card>{heading}</Heading.Card>
            <div className={st['service-pack-card__content']}>
                <div className={st['list-wrp']}>
                    {listTitle && <h5 className={st['list-title']}>{listTitle}</h5>}
                    <ul className={st['list']}>{list.map(item => <li className={st['list__item']}>{item}</li>)}</ul>
                </div>
                {children}
            </div>
            <Button2.Secondary size={T.Size.MEDIUM} onClick={onOrderBtnClick}>Заказать</Button2.Secondary>
        </div>
    );
};

export default ServicePackCard;